






















/**
 * 在表单项的Label上增加一个拒审理由
 */
import { defineComponent, computed, PropType } from '@vue/composition-api';
import { REJECT_TYPES } from '@tt4b/ttam-enums';
import { RejectReason } from './types';

const componentName = 'form-item-reject-reason';
export default defineComponent({
  name: componentName,
  props: {
    name: {
      type: [String, Array],
      default: '',
    },
    rejectReason: {
      type: Array as PropType<RejectReason[]>,
      default: () => [],
    },
    showRejectTipText: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const rejectType = computed(() => {
      const nameIsArray = Array.isArray(props.name);
      let reason = REJECT_TYPES.filter(item =>
        nameIsArray ? props.name.includes(item.name) : item.name === props.name,
      );
      return reason.map(({ reason_type }) => reason_type);
    });

    const rejectTip = computed(() => {
      let reasons = [];
      props.rejectReason.forEach(item => {
        if (rejectType.value.includes(item.reasonType)) {
          reasons = reasons.concat(item.reasons || []);
        }
      });
      return reasons;
    });

    const listStyle = computed(() => {
      const style = {
        'list-style': rejectTip.value.length > 1 ? 'disc' : 'none',
      };
      return style;
    });

    return { rejectTip, rejectType, listStyle, componentName };
  },
});
